import React, { FC } from 'react';
import { TABLE_COLUMN_KEYS } from '../../constants/table';
import Checkbox from '@atlaskit/checkbox';

interface Props {
  isChecked: boolean;
  handleFilter: (type: string, filterBy: boolean) => void;
}

export const UrgentFilter: FC<Props> = ({ isChecked, handleFilter }) => {
  return (
    <div className="due-date-checkbox">
      <Checkbox
        isChecked={isChecked}
        onChange={() => handleFilter(TABLE_COLUMN_KEYS.URGENT, !isChecked)}
        label="Show only 'Urgent' tasks"
        value="Controlled Checkbox"
        name="controlled-checkbox"
        data-testid="filter-urgent-checkbox"
      />
    </div>
  );
};
